import React from 'react';
import { Location } from 'history';
import { connect } from 'react-redux';
import { Header, Loader } from 'components';
import { SidebarContainer } from '../../containers';
import { IRootState } from '../../redux/store/configureStore';
import { useReloader } from 'hooks';
import styles from './AuthorizedLayout.module.scss';
import sidebarTabs from '../../routes/SidebarTabs';

const AuthorizedLayout = ({
                              children, location, auth, authProcessing,
                          }: Props) => {
    const reload = useReloader(location);

    return (
        <div className="wrapper">
            <SidebarContainer location={location} />
            <div className="main-panel">
                <Header location={location} tabs={sidebarTabs} />
                {reload ? null : (
                    <div data-test-authorized-content className={styles.content}>
                        {children}
                    </div>
                )}
            </div>
            {authProcessing && (!auth || (auth && !auth.profile)) ? <Loader showBg /> : null}
        </div>
    );
};

const mapState = (state: IRootState) => ({
    auth: state.auth,
    authProcessing: Boolean(state.loading.models.auth),
});

export default connect(mapState)(AuthorizedLayout);

type connectedProps = ReturnType<typeof mapState>;

interface OwnProps {
    children: JSX.Element[] | JSX.Element;
    location: Location;
}

type Props = connectedProps & OwnProps;
